import axios from "axios";
import router from "@/router";
import store from "@/store";
import Swal from "sweetalert2/dist/sweetalert2.js";
import i18n from "../plugins/i18n";
// import { detectReferrer } from "./general-function";

const BackendService = axios.create({
  baseURL: process.env.VUE_APP_API_SERVICE,
  withCredentials: true,
  headers: {
    "Content-type": "application/json",
    Accept: "application/json",
  },
});

BackendService.interceptors.request.use((config) => {
  let token = "";

  try {
    let userStorage = localStorage.getItem("token");
    token = userStorage;
    //set lang
    config.headers["X-localization"] = i18n.locale;
  } catch (error) {
    console.log(error);
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // const referrer = detectReferrer();
  // console.log(referrer)

  return config;
});

BackendService.interceptors.response.use(undefined, function (error) {
  if (error) {
    if (
      error.response.status === 401 &&
      !["getProfileNPS"].includes(error.config.url)
    ) {
      const keysLocalStorage = Object.keys(localStorage);
      if (keysLocalStorage.length != 0) {
        store.replaceState({ defaultSystem: {} });
        const code = localStorage.getItem("code");
        const mission_id = localStorage.getItem("mission_id");
        localStorage.clear();
        setTimeout(() => {
          if (!["", null, undefined, "undefined"].includes(code)) {
            localStorage.setItem("code", code);
            localStorage.setItem("mission_id", mission_id);
          }
        }, 0);
        // ========== ต้องเคลียร์ store ด้วย เนื่องจากมันจำค่า ต่อให้ localStorage.clear() แล้ว มันจะยัดค่าเดิมคืน ==========
        // store.commit("login/SET_MOBILE", { mobile: "" });
        // store.commit("defaultSystem/SET_USER", { role: "" }, { root: true });
        // store.commit("defaultSystem/SET_TOKEN", null, { root: true });
        // store.commit("defaultSystem/SET_CUSTOMER", {}, { root: true });
        setTimeout(() => {
          // return router.push({
          //     name: "check-login",
          // }).then(() => {
          //     location.reload();
          // });
          location.reload();
        }, 3000);
      }
    }
    if (error.response.status === 400) {
      Swal.fire({
        icon: "error",
        text: error.response.data.message,
        showConfirmButton: true,
        confirmButtonColor: "red",
        confirmButtonText: i18n.t("confirm"),
      });
    }
    if (error.response.status === 404) {
      if (error.response.data.status == "error_not_found_web") {
        return router.push({ name: "page-not-found" });
      } else if (error.response.data.status == "error_inactive") {
        store.commit("defaultSystem/SET_SITE", error.response.data.data);
        return router.push({
          name: "page-handle",
          query: { page: "inactive" },
        });
      } else {
        store.commit("defaultSystem/SET_SITE", error.response.data.data);
        return router.push({
          name: "page-handle",
          query: { page: "not_in_period" },
        });
      }
    }
  }
});

export default BackendService;
